import React from "react";
import { Typography, Box, makeStyles, IconButton } from "@material-ui/core";
import MROButton from "components/buttons";
import ButtonGroupNavigation from "components/button_group_navigation";
import { Route, Switch } from "react-router-dom";
import OilAccuracy from "./OilAccuracy/OilAccuracy";

const useStyles = makeStyles(theme => ({
    subNavigation: {
        margin: '2% 3%',
        width: '85%',
    }
}));
const buttons = [
    { name: "Oil Accuracy", redirect: "/org/dashboard/stores/oil_accuracy" },

];

export default function Stores(props) {

    const classes = useStyles();
    return (
        <div>
            <div className={classes.subNavigation}>
                <ButtonGroupNavigation buttons={buttons} {...props} />
            </div>
            <Switch>
                <Route exact path={'/org/dashboard/stores/oil_accuracy'} component={rprops => <OilAccuracy {...rprops} {...props} />} />

                <Route component={OilAccuracy} />
            </Switch>
        </div>
    )
}
